import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ThemeProvider } from '@mui/material/styles'
import OperationHeader from '../headers/operation.header'
import styles from './dre.module.scss'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TableContainer,
  Tooltip
} from '@mui/material'
import theme from '../../theme'
import { toStringFloat } from '../../utilities/auxiliary-functions'

function createData(
  name: string,
  january: string,
  february: string,
  march: string,
  april: string,
  may: string,
  june: string,
  july: string,
  august: string,
  september: string,
  october: string
) {
  return {
    name,
    january,
    february,
    march,
    april,
    may,
    june,
    july,
    august,
    september,
    october
  }
}

const categoryOptions = [
  {
    label: 'Manutenção',
    value: 'maintenance'
  },
  {
    label: 'Alimentação',
    value: 'food'
  },
  {
    label: 'Saúde e Beleza',
    value: 'healthAndBeauty'
  },
  {
    label: 'Transporte',
    value: 'transportation'
  },
  {
    label: 'Educação',
    value: 'education'
  },
  {
    label: 'Lazer',
    value: 'leisure'
  },
  {
    label: 'Outros',
    value: 'others'
  }
]
const monthOptions = [
  {
    label: 'Janeiro',
    value: 'january'
  },
  {
    label: 'Fevereiro',
    value: 'february'
  },
  {
    label: 'Março',
    value: 'march'
  },
  {
    label: 'Abril',
    value: 'april'
  },
  {
    label: 'Maio',
    value: 'may'
  },
  {
    label: 'Junho',
    value: 'june'
  },
  {
    label: 'Julho',
    value: 'july'
  },
  {
    label: 'Agosto',
    value: 'august'
  },
  {
    label: 'Setembro',
    value: 'september'
  },
  {
    label: 'Outubro',
    value: 'october'
  },
  {
    label: 'Novembro',
    value: 'november'
  },
  {
    label: 'Dezembro',
    value: 'december'
  }
]

const yearOptions = [
  {
    label: '2023',
    value: '2023'
  },
  {
    label: '2024',
    value: '2024'
  },
  {
    label: '2025',
    value: '2025'
  }
]
const DropdownProps = {
  PaperProps: {
    style: {
      width: 160,
      maxHeight: 500
    }
  }
}

export const ContractManagementFinancial: React.FC<any> = () => {
  const [selectedCategories, setSelectedCategories] = useState<Array<string>>(
    []
  )
  const [selectedYear, setSelectedYear] = useState<string>('2025')
  const [selectedInitialMonth, setSelectedInitialMonth] =
    useState<string>('january')
  const [selectedFinalMonth, setSelectedFinalMonth] =
    useState<string>('december')

  const title = `DRE`
  const description = `Demonstrativo de Resultados do Exercício`

  function viewPage() {
    return (
      <Container fluid className={`page-body movements ${styles.dre}`}>
        <div className="ps-3 pb-4 pt-2 d-flex justify-content-center">
          <FormControl
            sx={{ fontSize: 12, width: 230, marginRight: 25 }}
            size="medium"
          >
            <InputLabel sx={{ marginLeft: '-10px' }}>Conta</InputLabel>
            <Select
              labelId="selected-category"
              id="selected-category-select"
              variant="standard"
              size="medium"
              multiple
              value={selectedCategories}
              onChange={e =>
                setSelectedCategories(
                  typeof e.target.value === 'string'
                    ? [e.target.value]
                    : e.target.value
                )
              }
              label="Conta"
              MenuProps={DropdownProps}
            >
              {categoryOptions?.map(
                (
                  option: any,
                  index: {
                    toString: () => React.Key | null | undefined
                  }
                ) => (
                  <MenuItem
                    selected={selectedCategories.includes(option.value)}
                    key={index.toString()}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
          <div>
            <FormControl
              sx={{ fontSize: 12, width: 80, marginRight: 2 }}
              size="medium"
            >
              <InputLabel sx={{ marginLeft: '-10px' }}>Ano</InputLabel>
              <Select
                labelId="selected-category"
                id="selected-category-select"
                variant="standard"
                size="medium"
                value={selectedYear}
                onChange={e => setSelectedYear(e.target.value)}
                label="Conta"
                MenuProps={DropdownProps}
              >
                {yearOptions?.map(
                  (
                    option: any,
                    index: {
                      toString: () => React.Key | null | undefined
                    }
                  ) => (
                    <MenuItem
                      selected={selectedYear === option.value}
                      key={index.toString()}
                      value={option.value}
                    >
                      {option.label}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
            <FormControl
              sx={{ fontSize: 12, width: 130, marginRight: 2 }}
              size="medium"
            >
              <InputLabel sx={{ marginLeft: '-10px' }}>De</InputLabel>
              <Select
                labelId="selected-category"
                id="selected-category-select"
                variant="standard"
                size="medium"
                value={selectedInitialMonth}
                onChange={e => setSelectedInitialMonth(e.target.value)}
                label="Conta"
                MenuProps={DropdownProps}
              >
                {monthOptions?.map(
                  (
                    option: any,
                    index: {
                      toString: () => React.Key | null | undefined
                    }
                  ) => (
                    <MenuItem
                      selected={selectedInitialMonth === option.value}
                      key={index.toString()}
                      value={option.value}
                    >
                      {option.label}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
            <FormControl sx={{ fontSize: 12, width: 130 }} size="medium">
              <InputLabel sx={{ marginLeft: '-10px' }}>Até</InputLabel>
              <Select
                labelId="selected-category"
                id="selected-category-select"
                variant="standard"
                size="medium"
                value={selectedFinalMonth}
                onChange={e => setSelectedFinalMonth(e.target.value)}
                label="Conta"
                MenuProps={DropdownProps}
              >
                {monthOptions?.map(
                  (
                    option: any,
                    index: {
                      toString: () => React.Key | null | undefined
                    }
                  ) => (
                    <MenuItem
                      selected={selectedFinalMonth === option.value}
                      key={index.toString()}
                      value={option.value}
                    >
                      {option.label}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </div>
        </div>
        <Row>
          <Col md={12} className="page-sweet">
            <ThemeProvider theme={theme}>
              <TableContainer
                component={Paper}
                className={styles.tableContainer}
              >
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Tipo</TableCell>
                      <TableCell align="left">Janeiro</TableCell>
                      <TableCell align="left">Fevereiro</TableCell>
                      <TableCell align="left">Março</TableCell>
                      <TableCell align="left">Abril</TableCell>
                      <TableCell align="left">Maio</TableCell>
                      <TableCell align="left">Junho</TableCell>
                      <TableCell align="left">Julho</TableCell>
                      <TableCell align="left">Agosto</TableCell>
                      <TableCell align="left">Setembro</TableCell>
                      <TableCell align="left">Outubro</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (
                      <TableLine key={row.name} row={row} />
                    ))}
                  </TableBody>
                  <TableRow>
                    <TableCell style={{ width: 62 }} />
                    <TableCell>( = ) LUCRO LÍQUIDO</TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                    <TableCell>
                      {generateRandomValuesInReal(10000, 200000)}
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </ThemeProvider>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <div className="page">
      <OperationHeader title={title} description={description} />
      {viewPage()}
    </div>
  )
}

const generateRandomValuesInReal = (min: number, max: number) => {
  const randomValue = Math.random() * (max - min) + min
  return `R$ ${toStringFloat(randomValue.toFixed(2).toLocaleString())} `
}

const generateRandomValuesInRealWithDiff = (
  min: number,
  max: number,
  isNegative?: boolean
) => {
  const randomValue = Math.random() * (max - min) + min
  return (
    <div
      className="d-flex flex-column"
      style={{ width: 'auto', marginRight: 25 }}
    >
      <Tooltip title="Realizado" placement="top">
        <span className={isNegative ? styles.textError : styles.textSuccess}>
          {`R: ${isNegative ? '-' : ''} R$ ${toStringFloat(
            randomValue.toFixed(2).toLocaleString()
          )} `}
        </span>
      </Tooltip>
      <br />
      <Tooltip title="Orçado" placement="top">
        <span className={isNegative ? styles.textError : styles.textSuccess}>
          {`O: ${isNegative ? '-' : ''} R$ ${toStringFloat(
            randomValue.toFixed(2).toLocaleString()
          )} `}
        </span>
      </Tooltip>
      <br />
      <Tooltip title="Diferença" placement="top">
        <strong
          className={isNegative ? styles.textError : styles.textSuccess}
        >{`D: ${isNegative ? '-' : ''} R$ ${toStringFloat(
          randomValue.toFixed(2).toLocaleString()
        )}  ${' '} |
         ${isNegative ? '-' : ''} ${(Math.random() * 100).toFixed(
          2
        )}%`}</strong>
      </Tooltip>
    </div>
  )
}

const rows = [
  createData(
    '( + ) RECEITA BRUTA',
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000)
  ),
  createData(
    '( = ) RECEITA LÍQUIDA',
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000)
  ),
  createData(
    '( = ) LUCRO BRUTO',
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000),
    generateRandomValuesInReal(10000, 200000)
  )
  // createData('', 'R$ 24.891,31', 'R$ 24.891,31', 0, 0, 4.3),
  // createData('Lucro Bruto', 'R$ 24.891,31', 'R$ 24.891,31', 0, 0, 4.6),
]
function TableLine(props: { row: ReturnType<typeof createData> }) {
  const { row } = props
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="left">{row.january}</TableCell>
        <TableCell align="left">{row.february}</TableCell>
        <TableCell align="left">{row.march}</TableCell>
        <TableCell align="left">{row.april}</TableCell>
        <TableCell align="left">{row.may}</TableCell>
        <TableCell align="left">{row.june}</TableCell>
        <TableCell align="left">{row.july}</TableCell>
        <TableCell align="left">{row.august}</TableCell>
        <TableCell align="left">{row.september}</TableCell>
        <TableCell align="left">{row.october}</TableCell>
      </TableRow>
      <TableRow className={styles.tableRow}>
        <TableCell style={{ padding: '0' }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              className="m-3"
            >
              Consolidado
            </Typography>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 62 }} />
                  <TableCell>Tipo</TableCell>
                  <TableCell>Janeiro</TableCell>
                  <TableCell>Fevereiro</TableCell>
                  <TableCell>Março</TableCell>
                  <TableCell>Abril</TableCell>
                  <TableCell>Maio</TableCell>
                  <TableCell>Junho</TableCell>
                  <TableCell>Julho</TableCell>
                  <TableCell>Agosto</TableCell>
                  <TableCell>Setembro</TableCell>
                  <TableCell>Outubro</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.name === '( + ) RECEITA BRUTA' && (
                  <>
                    <TableRow>
                      <TableCell />
                      <TableCell component="th" scope="row">
                        Vendas de produtos
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        Outras receitas
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(10000, 200000)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) Devoluções de Produtos
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) Taxas de Serviço
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                  </>
                )}

                {row.name === '( = ) RECEITA LÍQUIDA' && (
                  <>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) Custo do Produto
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) OUTROS CUSTOS
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                {row.name === '( = ) LUCRO BRUTO' && (
                  <>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) Despesas administrativas
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) DESPESAS FINANCEIRAS
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) TECNOLOGIA DA INFORMAÇÃO
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) RECURSOS HUMANOS
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) RELACIONAMENTO COM CLIENTE
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) MARKETING E DIVULGAÇÃO
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) IMPOSTOS ESTADUAIS
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />

                      <TableCell component="th" scope="row">
                        ( - ) IMPOSTOS FEDERAIS
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                      <TableCell>
                        {generateRandomValuesInRealWithDiff(
                          10000,
                          200000,
                          true
                        )}
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export default ContractManagementFinancial

